import React, { Component } from "react";
import Select from "react-select";

class VariantSelector extends Component {
  render() {
    var colourOptions = [];

    this.props.option.values.map((value) => {
      colourOptions.push({
        value: `${value}`,
        label: `${value}`,
      });
    });

    var field_Name = this.props.fieldName

    if (field_Name === "Size") {
      return (
        <div className="color_select">
          <Select
            className="basic-single"
            classNamePrefix="select"
            name={this.props.fieldName}
            options={colourOptions}
            defaultValue={colourOptions[0]}
            onChange={(e) => this.props.handleOptionChange(e, field_Name)}
            value={colourOptions.filter(
              ({ value }) => value === this.props.selectedSizeValue
            )}
          />
        </div>
      );
    }
    else if (field_Name === "Color") {
      return (
        <div className="color_select">
          <Select
            className="basic-single"
            classNamePrefix="select"
            name={this.props.fieldName}
            defaultValue={colourOptions[0]}
            options={colourOptions}
            onChange={(e) => this.props.handleOptionChange(e, field_Name)}
            value={this.props.selectedColorValue && colourOptions.filter(
              ({ value }) => value === this.props.selectedColorValue
            )}
          />
        </div>
      );
    }
    else {
      return (
        <div className="color_select">
          <Select
            className="basic-single"
            classNamePrefix="select"
            name={this.props.fieldName}
            defaultValue={colourOptions[0]}
            options={colourOptions}
            onChange={(e) => this.props.handleOptionChange(e, field_Name)}
            value={this.props.selectedColorValue && colourOptions.filter(
              ({ value }) => value === this.props.selectedColorValue
            )}
          />
        </div>
      );
    }
  }
}

export default VariantSelector;


// WEBPACK FOOTER //
// ./src/components/VariantSelector.js